export default __webpack_public_path__ + "static/media/gd_3.ae672118.jpg";